class NewsletterPopup extends HTMLElement {
    constructor() {
        super();

        this.popup = this;
        this.timeToShow = parseInt(this.popup.getAttribute('data-delay'));
        this.expiresDate = this.popup.getAttribute('data-expire');
        this.sliderContainer = document.querySelector('.sliderContainer');

        if (!this.sliderContainer) {
            console.error('sliderContainer not found!');
            return;
        }

        this.isSliderVisible = true; // Default state when the page loads.

        // Initialize the Intersection Observer.
        this.initObserver();

        if (this.getCookie('newsletter-popup') === '') {
            setTimeout(() => {
                if (!this.isSliderVisible) {
                    document.body.classList.add('newsletter-show');
                }
            }, this.timeToShow);

            setTimeout(() => {
                if (!this.isSliderVisible) {
                    document.body.classList.add('show-newsletter-image');
                }
            }, this.timeToShow + 700);
        }

        document.body.addEventListener('click', this.onBodyClickEvent.bind(this));

        this.querySelector('[data-close-newsletter-popup]').addEventListener(
            'click',
            this.setClosePopup.bind(this)
        );

        this.querySelector('#ContactPopup').addEventListener(
            'submit',
            this.setClosePopup.bind(this)
        );
    }

    initObserver() {
        const observer = new IntersectionObserver(
            (entries) => {
                const entry = entries[0];
                this.isSliderVisible = entry.isIntersecting;

                // Remove classes when sliderContainer is visible.
                if (this.isSliderVisible) {
                    document.body.classList.remove('newsletter-show', 'show-newsletter-image');
                } else {
                    // Add classes if sliderContainer is NOT visible and cookie allows.
                    if (this.getCookie('newsletter-popup') === '') {
                        document.body.classList.add('newsletter-show');
                        document.body.classList.add('show-newsletter-image');
                    }
                }
            },
            {
                root: null, // Use the viewport as the root.
                threshold: 0.1, // Trigger when 10% of the element is visible.
            }
        );

        observer.observe(this.sliderContainer);
    }

    setCookie(cname, cvalue, exdays) {
        const d = new Date();
        d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
        const expires = 'expires=' + d.toUTCString();
        document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
    }

    getCookie(cname) {
        const name = cname + '=';
        const ca = document.cookie.split(';');

        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) === ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) === 0) {
                return c.substring(name.length, c.length);
            }
        }

        return '';
    }

    deleteCookie(name) {
        document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    }

    setClosePopup() {
        this.setCookie('newsletter-popup', 'closed', this.expiresDate);
        document.body.classList.remove('newsletter-show');
        setTimeout(() => {
            document.body.classList.remove('show-newsletter-image');
        }, 700);
    }

    onBodyClickEvent(event) {
        if (
            !this.contains(event.target) &&
            $(event.target).closest('[data-open-newsletter-popup]').length === 0 &&
            document.querySelector('body').classList.contains('newsletter-show')
        ) {
            this.setClosePopup();
        }
    }
}

customElements.define('newsletter-popup', NewsletterPopup);
